import gql from 'graphql-tag';

export const destinationCarouselFragment = {
    searchResult: gql`
        fragment DestinationRecommendationResponse on SearchResult {
            destinationRecommendationResponse(
                size: 3
                target: SERP_LARGE_SEARCH_TERM_DESTINATION
            ) {
                clientRequestId
                recommendedDestinations {
                    searchTermUuid
                    imageHref
                    recommendationModel
                    place {
                        name {
                            simple
                            full
                        }
                    }
                }
            }
        }
    `,
};
